module.exports = __webpack_public_path__ + "media/images/flags/mc-f3da706de25d23f89f9c530b06b008fd.svg";